import { isEmpty } from "lodash";
import get from "lodash/get";
import { createSelector } from "reselect";

// ***************************************************************
// ******** IncomingInternationalCallsSMSForm selectors **********
// ***************************************************************
const guestOrderDomain = state => get(state.api, "guestOrder.data", {});

export const incomingInternationalCallsSMSDomain = state =>
  get(state.api, "setIncomingInternationalDetails.data", false);

export const incomingInternationalCallsSMSSelector = state => {
  let sim_type_attributes = {
    allow_incoming_international_calls: JSON.parse(
      get(
        state,
        "form.IncomingInternationalCallsSMSForm.values.allow_incoming_international_calls",
        true
      )
    ),
    allow_incoming_international_sms: JSON.parse(
      get(
        state,
        "form.IncomingInternationalCallsSMSForm.values.allow_incoming_international_sms",
        true
      )
    )
  };
  return sim_type_attributes;
};
export const isIncomingInternationalCallsSMSFormDirtySelector = createSelector(
  incomingInternationalCallsSMSSelector,
  guestOrderDomain,
  incomingInternationalCallsSMSDomain,
  (
    incomingInternationalCallsSMS,
    guestOrder,
    incomingInternationalCallsSMSSubmittedValue
  ) => {
    let BIIC = get(
      incomingInternationalCallsSMSSubmittedValue,
      "biic.result.setting_option.value"
    );
    let BIIS = get(
      incomingInternationalCallsSMSSubmittedValue,
      "biis.result.setting_option.value"
    );

    let guestOrderData = {
      allow_incoming_international_calls: !JSON.parse(
        get(guestOrder, "block_incoming_international_calls", true)
      ),
      allow_incoming_international_sms: !JSON.parse(
        get(guestOrder, "block_incoming_international_sms", true)
      )
    };

    let incomingInternationalCallsSMSData = {
      allow_incoming_international_calls: BIIC === "enable" ? false : true,
      allow_incoming_international_sms: BIIS === "enable" ? false : true
    };

    if (!isEmpty(incomingInternationalCallsSMSSubmittedValue)) {
      return (
        !incomingInternationalCallsSMS ||
        JSON.stringify(incomingInternationalCallsSMS) !==
          JSON.stringify(incomingInternationalCallsSMSData)
      );
    } else {
      return (
        !incomingInternationalCallsSMS ||
        !guestOrder ||
        JSON.stringify(incomingInternationalCallsSMS) !==
          JSON.stringify(guestOrderData)
      );
    }
  }
);

export const incomingInternationalCommsDetailsSelector = createSelector(
  incomingInternationalCallsSMSDomain,
  incomingInternationalCallsSMS => incomingInternationalCallsSMS
);

export const incomingInternationalInitialValuesSelector = createSelector(
  guestOrderDomain,
  guestOrder => {
    return {
      allow_incoming_international_calls: !JSON.parse(
        get(guestOrder, "block_incoming_international_calls", true)
      ),
      allow_incoming_international_sms: !JSON.parse(
        get(guestOrder, "block_incoming_international_sms", true)
      )
    };
  }
);

// ***************************************************************
// ******* IncomingInternationalCallsSMSForm makeSelect **********
// ***************************************************************

export const makeSelectIncomingInternationalCallsSMSForm = () =>
  incomingInternationalCallsSMSSelector;

export const makeSelectIncomingInternationalCallsSMSData = () =>
  incomingInternationalCommsDetailsSelector;

export const makeSelectIncomingInternationalCallsSMSFormIsDirty = () =>
  isIncomingInternationalCallsSMSFormDirtySelector;

export const makeSelectIncomingInternationalInitialValues = () =>
  incomingInternationalInitialValuesSelector;
